import { Box } from "@bca/ui-library";

import { formatSaleDate } from "../formatSaleDate";
import { Vehicle } from "../Interfaces/vehicle.type";
import KeyDecisionInfo from "../KeyDecisionInfo";
import {
  fuelMapper,
  transmissionMapper,
} from "../Mappers/vehicleDetailsMappers";
import SecondaryInfo from "../SecondaryInfo";
import PrimaryVehicleDetails from "./PrimaryVehicleDetails";

interface DetailsContainerProps {
  vehicle: Vehicle;
  degradedServices: string[];
}

const DetailsContainer: React.FunctionComponent<DetailsContainerProps> = ({
  vehicle,
  degradedServices = [],
}) => {
  const vehicleDoors = Boolean(vehicle.doors) ? `${vehicle.doors} doors` : null;
  const mediaServerServiceDegraded =
    degradedServices?.includes("MediaServerService");
  return (
    <Box display="flex" flexDirection="column" height="fit-content">
      <SecondaryInfo
        items={[
          formatSaleDate(vehicle.saleDate),
          vehicle.location,
          vehicle.saleSection,
        ]}
      />
      <PrimaryVehicleDetails vehicle={vehicle} />
      <KeyDecisionInfo
        vehicle={vehicle}
        mediaServerServiceDegraded={mediaServerServiceDegraded}
      />
      <SecondaryInfo
        items={[
          vehicle.color?.toLowerCase(),
          fuelMapper[vehicle.fuel] || vehicle.fuel,
          transmissionMapper[vehicle.transmission] || vehicle.transmission,
          vehicleDoors,
        ]}
      />
    </Box>
  );
};

export default DetailsContainer;
